import { Search } from "lucide-react";
import { AffiliateCard } from "@/components/AffiliateCard";
import type { DiagnosticInsight } from "../lib/types";

const STYLES: Record<DiagnosticInsight["type"], { wrap: string; icon: string }> = {
  alert: {
    wrap: "border-danger/30 bg-danger/5 text-foreground",
    icon: "text-danger",
  },
  opportunity: {
    wrap: "border-primary/30 bg-primary/5 text-foreground",
    icon: "text-primary",
  },
  positive: {
    wrap: "border-success/30 bg-success/5 text-foreground",
    icon: "text-success",
  },
};

interface Props {
  insights: DiagnosticInsight[];
}

export function DiagnosticInsights({ insights }: Props) {
  if (insights.length === 0) return null;

  // Limite à 2 affiliés visibles dans cette section (anti-spam)
  let affiliateShown = 0;

  return (
    <section className="mx-auto max-w-6xl px-6 py-6 lg:px-12">
      <div className="mb-5">
        <h2 className="flex items-center gap-2 text-xl font-bold text-foreground sm:text-2xl">
          <Search className="h-5 w-5 text-primary" aria-hidden />
          Ce que l'IA a détecté dans votre projet
        </h2>
        <p className="mt-1 text-sm text-muted-foreground">
          {insights.length} {insights.length > 1 ? "points clés" : "point clé"} repérés à partir de vos données
        </p>
      </div>
      <ul className="space-y-3">
        {insights.map((i) => {
          const showAffiliate = i.affiliate && affiliateShown < 2;
          if (showAffiliate) affiliateShown += 1;
          const style = STYLES[i.type];
          const IconCmp = i.icon;
          return (
            <li key={i.id} className={`rounded-xl border p-4 ${style.wrap}`}>
              <div className="flex items-start gap-3">
                <IconCmp
                  className={`h-5 w-5 shrink-0 mt-0.5 ${style.icon}`}
                  aria-hidden
                />
                <p className="text-sm font-medium leading-relaxed sm:text-base">
                  {i.title}
                </p>
              </div>
              {showAffiliate && i.affiliate && (
                <div className="mt-3">
                  <AffiliateCard
                    variant={i.affiliate}
                    placement={`results-diagnostic-${i.id}`}
                    compact
                    dismissibleId={`diag-${i.id}`}
                  />
                </div>
              )}
            </li>
          );
        })}
      </ul>
    </section>
  );
}
